import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

// Images
import MajesticConcert from '../AllImages/Concert.jpg';
import Logo from '../AllImages/GetItRight.png';

const SignInPage = () => {
  const navigate = useNavigate();
  const auth = getAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // We'll show error messages in red, and reset success message in green
  const [error, setError] = useState('');
  const [resetMsg, setResetMsg] = useState('');

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setResetMsg('');

    try {
      // Sign in the user with Firebase Auth
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      console.log('User signed in:', userCredential.user);

      const user = userCredential.user;
      // Use displayName if available; otherwise fallback to email as the name
      const name = user.displayName || user.email;

      // Check if this user is in the "Staff" collection (Admin)
      const staffRef = collection(db, 'Staff');
      const staffQuery = query(staffRef, where('primaryContact.email', '==', email));
      const staffSnapshot = await getDocs(staffQuery);

      if (!staffSnapshot.empty) {
        // If found in Staff, user is an Admin
        navigate('/Admin', { state: { uid: user.uid, name } });
      } else {
        // Otherwise, assume user is a Client
        navigate('/DashBoard', { state: { uid: user.uid, name } });
      }
    } catch (err) {
      console.error('Sign in error:', err);
      setError(err.message);
    }
  };

  // Handle "Forgot Password" -> send password reset email
  const handleForgotPassword = async () => {
    setError('');
    setResetMsg('');

    if (!email) {
      setError('Please enter your email first.');
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      setResetMsg(`A password reset link has been sent to ${email}.`);
    } catch (err) {
      console.error('Reset password error:', err);
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-800 text-gray-100 relative">
      {/* Back Button */}
      <div className="absolute top-4 left-4 z-20">
        <button
          onClick={() => navigate("/")}
          className="bg-yellow-500 opacity-60 text-black px-3 py-1 rounded hover:bg-yellow-400 transition-colors"
        >
      Regresar
        </button>
      </div>

      {/* Hero / Header Section */}
      <div className="relative flex-grow">
        {/* Background Image */}
        <img
          src={MajesticConcert}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/70" />

        {/* Content Container */}
        <div className="relative z-10 flex flex-col items-center justify-center h-full py-10 px-4">
          {/* Logo & Title */}
          <div className="text-center mb-8">
            <img
              src={Logo}
              alt="Main Logo"
              className="mx-auto mb-3 h-20 w-auto md:h-24"
            />
            <h1 className="text-3xl md:text-4xl font-bold text-yellow-400">
          Initialize
            </h1>
            <p className="text-sm md:text-base text-gray-200 mt-2">
           Enter account
            </p>
          </div>

          {/* Sign In Form Card */}
          <div className="bg-gray-700 p-8 rounded shadow-md w-full max-w-md">
            {error && (
              <div className="mb-4 text-red-500 text-center font-semibold">
                {error}
              </div>
            )}
            {resetMsg && (
              <div className="mb-4 text-green-400 text-center font-semibold">
                {resetMsg}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="email" className="block text-gray-200 font-medium">
                Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 w-full border border-gray-600 rounded p-2 bg-gray-600 text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  placeholder="you@example.com"
                  required
                />
              </div>

              <div>
                <label htmlFor="password" className="block text-gray-200 font-medium">
               Password
                </label>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 w-full border border-gray-600 rounded p-2 bg-gray-600 text-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  placeholder="********"
                  required
                />
              </div>

              {/* Forgot Password Link */}
              <div className="text-right">
                <button
                  type="button"
                  onClick={handleForgotPassword}
                  className="text-sm text-yellow-400 hover:underline"
                >
                   Forgot Password?
                </button>
              </div>

              <button
                type="submit"
                className="w-full bg-yellow-500 text-black py-2 rounded font-semibold hover:bg-yellow-400 transition-colors"
              >
            Sign-In
              </button>
            </form>

            <p className="mt-4 text-center text-gray-300">
            Don't have an account?{' '}
              <a href="/Onboard" className="text-yellow-400 hover:underline">
              Register

              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
